module.exports = __webpack_public_path__ + "img/laptop-money-banknote.1db5db9b.svg";